import { Box, Button, Dialog, List, ListItem, makeStyles, Typography } from "@material-ui/core";
import { useState } from "react";
import BSC from "src/assets/images/tokens/BSC.svg";
import ETH from "src/assets/images/tokens/ETH.png";
import FTM from "src/assets/images/tokens/FTM.svg";
import DialogContent from "src/components/Dialog/DialogContent";
import DialogTitle from "src/components/Dialog/DialogTitle";
import { useWeb3Connect } from "src/wallet-connection/context/we3-connect-context";

const useStyles = makeStyles((theme) => ({
  root: {
    borderWidth: 1,
    borderRadius: 6,
    textTransform: "capitalize",
  },
  list: {
    display: "flex",
  },
  listItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(2),
    borderRadius: 10,
  },
}));

const chainConfig = () => {
  let networkConfig = [
    { chainId: 56, image: BSC, name: "BSC Mainnet", width: "60px" },
    { chainId: 250, image: FTM, name: "FTM Mainnet", width: "50px" },
    { chainId: 1, image: ETH, name: "ETH Mainnet", width: "60px" },
  ];
  if (process.env.REACT_APP_TESTNET === "true")
    networkConfig.push({ chainId: 97, image: BSC, name: "BSC Testnet", width: "60px" });
  return networkConfig;
};

export default function ToggleNetworkButton(props) {
  const { chain, switchChain } = useWeb3Connect();
  const cls = useStyles();
  const [isOpenDialog, setIsOpenDialog] = useState(false);

  const handleOpen = () => {
    setIsOpenDialog(true);
  };

  const onClose = () => {
    setIsOpenDialog(false);
  };

  const changeNetwork = async (chainId) => {
    await switchChain(chainId);
    onClose();
  };

  return (
    <>
      <Button className={cls.root} variant="outlined" color="primary" onClick={handleOpen} {...props}>
        <Box display="flex" alignItems="center">
          {chain?.name}
        </Box>
      </Button>
      <Dialog open={isOpenDialog} onClose={onClose} PaperProps={{ style: { padding: 0 } }}>
        <DialogTitle disableTypography>
          <Typography align="left" variant="h6">
            Select Network
          </Typography>
        </DialogTitle>
        <DialogContent>
          <List className={cls.list} disablePadding>
            {chainConfig().map((item) => (
              <ListItem key={item.chainId} button className={cls.listItem} onClick={() => changeNetwork(item.chainId)}>
                <Box height={70}>
                  <img src={item.image} height={50} alt={item.name} />
                </Box>
                <Typography noWrap>{item.name}</Typography>
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>
    </>
  );
}
